import React, { Component, Fragment, } from 'react';
import Radio from './Radio';
export default class RadioGroup extends Component {
    constructor(props) {
        super(props);
        this.getProp = (key) => {
            return this.props[key] ? this.props[key] : this.state[key];
        };
        this.onChange = event => {
            this.setState({
                value: event.currentTarget.value,
            });
            this.props.onChange(event);
        };
        this.buildOptions = () => {
            const { options, isDisabled, isRequired, onInvalid, name } = this.props;
            const value = this.getProp('value');
            if (!options.length)
                return [];
            return options.map(({ testId, ...optionProps }, index) => {
                if (typeof isDisabled !== 'undefined') {
                    optionProps.isDisabled = isDisabled;
                }
                if (value !== null && optionProps.value === value) {
                    optionProps.isChecked = true;
                }
                return (React.createElement(Radio, Object.assign({}, optionProps, { name: name || optionProps.name, key: index, onChange: this.onChange, onInvalid: onInvalid, isRequired: isRequired, testId: testId })));
            });
        };
        this.state = {
            value: this.props.value !== undefined
                ? this.props.value
                : this.props.defaultValue,
        };
    }
    render() {
        const options = this.buildOptions();
        return React.createElement(Fragment, null, options);
    }
}
RadioGroup.defaultProps = {
    onChange: () => { },
    options: [],
};
//# sourceMappingURL=RadioGroup.js.map